import React, { SVGProps } from "react";

interface AddIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const AddIcon: React.FC<AddIconProps> = ({ color = "white", size = 17, ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_11840_5578)">
        <path
          d="M12.2685 9.11496H9.11198V12.2715C9.11198 12.6187 8.82789 12.9028 8.48067 12.9028C8.13344 12.9028 7.84935 12.6187 7.84935 12.2715V9.11496H4.69279C4.34556 9.11496 4.06147 8.83087 4.06147 8.48365C4.06147 8.13642 4.34556 7.85233 4.69279 7.85233H7.84935V4.69577C7.84935 4.34854 8.13344 4.06445 8.48067 4.06445C8.82789 4.06445 9.11198 4.34854 9.11198 4.69577V7.85233H12.2685C12.6158 7.85233 12.8999 8.13642 12.8999 8.48365C12.8999 8.83087 12.6158 9.11496 12.2685 9.11496Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_11840_5578">
          <rect
            width="15.1515"
            height="15.1515"
            fill="white"
            transform="translate(0.904751 0.908203)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AddIcon;
